module.exports = __webpack_public_path__ + "img/s6.a512e881.png";